<template>
	<div class="chars-form">
		<div class="chars-form__characteriscts">
			<div class="chars-form__characteriscts-title" @click="toggleCollapseAllCharacteristics">
				<h1 class="chars-form__characteriscts-title--text">Características</h1>
				<div
					class="chars-form__characteriscts-form--input__icon"
					:class="allCharacteristicsCollapsed ? '' : 'isOpen'"
					v-if="isEditing"
				>
					<ArrowIcon />
				</div>
			</div>
			<div v-show="!shouldCollapseCharacteristics" class="chars-form__collapsible-content">
				<draggable
					class="drag-list"
					:options="dragOptions"
					:list="offer.offerCharacteristics"
					v-if="offer.offerCharacteristics.length"
				>
					<div
						class="chars-form__characteriscts-form"
						v-for="(characteristics, index) in offer.offerCharacteristics"
						:key="index"
					>
						<div class="chars-form__direction">
							<div class="chars-form__characteriscts-form--move">
								<MoveIcon />
							</div>
							<div class="chars-form__characteriscts-form--input w-100" style="position: relative">
								<InputGroup
									:title="'Título da Característica'"
									:customClass="'full'"
									:id="'characteristic_title'"
									:placeholder="'Título da Característica'"
									v-model="characteristics.label"
								/>
								<div
									class="chars-form__characteriscts-form--input__icon"
									:class="isCharacteristicsOpen.includes(characteristics.index) ? 'isOpen' : ''"
									@click="openChars(characteristics)"
								>
									<ArrowIcon />
								</div>
							</div>
						</div>
						<transition name="fadeHeight">
							<div
								class="chars-form__characteriscts-form--textarea"
								v-show="isCharacteristicsOpen.includes(characteristics.index)"
							>
								<InputGroup
									:title="'Descrição'"
									:customClass="'textarea long'"
									:id="'characteristic_description'"
									:placeholder="'Mensagem'"
									:isTextArea="true"
									v-model="characteristics.description"
								/>
							</div>
						</transition>
						<div
							class="chars-form__characteriscts-form--delete"
							v-show="isCharacteristicsOpen.includes(characteristics.index)"
							@click="removeChars(characteristics)"
						>
							<span>Excluir Característica</span>
						</div>
					</div>
				</draggable>
				<span
					class="chars-form__characteriscts-title--icon chars-form__characteriscts-title--subText"
					@click="addNewChars()"
				>
					Incluir Característica <PlusIconVariant />
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import PlusIconVariant from '@/components/shared/Icons/PlusIconVariant.vue';
import ArrowIcon from '@/components/shared/Icons/ArrowIcon.vue';
import MoveIcon from '@/components/shared/Icons/MoveIcon.vue';

export default {
	name: 'OfferCharsForm',
	components: {
		draggable,
		InputGroup,
		PlusIconVariant,
		ArrowIcon,
		MoveIcon,
	},
	data: () => ({
		offer: {
			offerCharacteristics: [
				{
					label: null,
					description: null,
					index: 1,
				},
			],
		},
		isCharacteristicsOpen: [1],
		allCharacteristicsCollapsed: true,
	}),
	props: {
		isEditing: {
			required: true,
			type: Boolean,
		},
	},
	methods: {
		openChars(isCharacteristicsOpen) {
			const index = this.isCharacteristicsOpen.indexOf(isCharacteristicsOpen.index);

			this.isCharacteristicsOpen =
				index === -1
					? [...this.isCharacteristicsOpen, isCharacteristicsOpen.index]
					: this.isCharacteristicsOpen.filter((item) => item !== isCharacteristicsOpen.index);
		},
		addNewChars() {
			this.offer.offerCharacteristics.push({
				label: null,
				description: null,
				index: this.offer.offerCharacteristics.length + 1,
			});
		},
		removeChars(param) {
			this.offer.offerCharacteristics = this.offer.offerCharacteristics.filter(
				(char) => char.index != param.index,
			);

			this.offer.offerCharacteristics.forEach((char) => {
				char.index = char.index - 1;
			});
		},
		loadOfferDetails(selectedOffer) {
			this.offer.offerCharacteristics = selectedOffer.offerCharacteristics.map((chars) => {
				const { priority, ...otherProps } = chars;
				return { index: priority, ...otherProps };
			});

			this.isCharacteristicsOpen = selectedOffer.offerCharacteristics.map(
				(chars) => chars.priority,
			);
		},
		getCharsData() {
			return this.offer;
		},
		toggleCollapseAllCharacteristics() {
			this.allCharacteristicsCollapsed = !this.allCharacteristicsCollapsed;
		},
	},
	computed: {
		shouldCollapseCharacteristics() {
			return this.isEditing && this.allCharacteristicsCollapsed;
		},
		dragOptions() {
			return {
				animation: 200,
				group: 'description',
				disabled: false,
				ghostClass: 'ghost',
			};
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferCharsForm.scss';
</style>
